import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// 3rd Party
import Collapse from 'react-collapse';
import { StickyContainer, Sticky } from 'react-sticky';

const mapStateToProps = state => ({
  headerIsPinned: state.headerIsPinned,
  isMobile: state.isMobile
});

class TeaserText extends React.Component {
  constructor(props) {
    super(props);

    let backgroundVideo = false,
      sectionStyle = {};

    if (props.content.teaser_image) {
      sectionStyle = { backgroundImage: `url('${require(`../../../public/content/assets/${props.content.teaser_image}`)}')` };
    }

    if (props.content.teaser_video) {
      backgroundVideo = `/public/content/assets/${props.content.teaser_video}`;
    }

    this.state = {
      backgroundVideo,
      sectionStyle,
      stickyMarginTop: -25,
      teaserTextUrl: `/${props.content.heading.replace(/\s/g, '-').toLowerCase()}`
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.headerIsPinned !== nextProps.headerIsPinned) {
      if (nextProps.headerIsPinned) {
        if (this.props.isMobile) {
          this.setState({ stickyMarginTop: 85 });
        } else {
          this.setState({ stickyMarginTop: 85 });
        }
      } else {
        if (this.props.isMobile) {
          this.setState({ stickyMarginTop: -45 });
        } else {
          this.setState({ stickyMarginTop: -25 });
        }
      }
    }
  }

  componentDidMount() {
    if (this.props.headerIsPinned) {
      if (this.props.isMobile) {
        this.setState({ stickyMarginTop: 85 });
      } else {
        this.setState({ stickyMarginTop: 85 });
      }
    } else {
      if (this.props.isMobile) {
        this.setState({ stickyMarginTop: -45 });
      } else {
        this.setState({ stickyMarginTop: -25 });
      }
    }
  }

  render() {
    return (
      <Router>
        <section className={this.props.content.visible ? `teaser-text optional ${this.state.teaserTextUrl.replace('/', '')}` : `teaser-text ${this.state.teaserTextUrl.replace('/', '')}`}>
          <Route path={this.state.teaserTextUrl} children={({ match }) => (
            <div>
              <StickyContainer>
                <div className="teaser-wrap" style={this.state.sectionStyle}>
                  {typeof this.state.backgroundVideo === 'string' && !this.props.isMobile &&
                    <div className="video-wrap">
                      <video autoPlay loop>
                        <source src={this.state.backgroundVideo} type="video/mp4" />
                        Your browser does not support HTML5 video.
                      </video>
                    </div>
                  }
                  <div className="wrap">
                    <h2>{this.props.content.heading}</h2>
                    <div className="teaser-text">
                      <p dangerouslySetInnerHTML={{ __html: this.props.content.teaser_text }} />
                    </div>
                    <Sticky isActive={match} topOffset={this.props.headerIsPinned ? 25 : 25} stickyStyle={{ marginTop: this.state.stickyMarginTop }}>
                      <Link to={match ? '/' : this.state.teaserTextUrl} className={match ? 'read-more active' : 'read-more'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                          <g>
                            <path d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                          </g>
                        </svg>
                      </Link>
                    </Sticky>
                  </div>
                </div>

                <div className="wrap">
                  <Collapse isOpened={match} className="full-text" style={{ textAlign: this.props.content.main_text_align }}>
                    <div className="inner" dangerouslySetInnerHTML={{ __html: this.props.content.main_text }} />
                  </Collapse>
                </div>
              </StickyContainer>
            </div>
          )} />
        </section>
      </Router>
    );
  }
}

export default connect(mapStateToProps)(TeaserText);


// WEBPACK FOOTER //
// ./src/sections/teaser-text/teaser-text.jsx